export default "__VITE_ASSET__BM$XW5j6__"